import { useEffect, useState } from 'react';
import { api } from '@/api/client';
import { Skeleton } from '@/components/ui/skeleton';
import { Trophy, Crown, PenLine } from 'lucide-react';

const RANK_STYLE = [
  'bg-amber-500 text-white',
  'bg-stone-400 text-white',
  'bg-amber-800 text-white',
];

export default function TopContributors() {
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.functions.invoke('topContributors', {})
      .then((res) => {
        setContributors(res.data?.contributors || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (!loading && contributors.length === 0) return null;

  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <Trophy size={16} className="text-primary" strokeWidth={2} />
        <h2 className="font-heading font-semibold text-base">Top Contributors</h2>
      </div>
      {loading ? (
        <div className="space-y-3">
          {Array(3).fill(0).map((_, i) => (
            <Skeleton key={i} className="h-14 rounded-2xl" />
          ))}
        </div>
      ) : (
        <div className="space-y-2">
          {contributors.map((c, i) => (
            <div
              key={c.reviewer_id}
              className="flex items-center gap-3 bg-card rounded-2xl border border-border p-3"
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${RANK_STYLE[i] || 'bg-secondary text-muted-foreground'}`}>
                {i === 0 ? <Crown size={15} /> : i + 1}
              </div>
              <div className="w-9 h-9 rounded-full bg-secondary flex items-center justify-center text-sm font-semibold text-primary shrink-0 overflow-hidden">
                {c.avatar_url ? (
                  <img src={c.avatar_url} alt={c.reviewer_name || 'avatar'} className="w-full h-full object-cover" />
                ) : (
                  (c.reviewer_name || 'A').charAt(0).toUpperCase()
                )}
              </div>
              <p className="flex-1 min-w-0 text-sm font-medium text-foreground truncate">
                {c.reviewer_name}
              </p>
              <div className="flex items-center gap-1.5 text-xs text-muted-foreground shrink-0">
                <PenLine size={13} />
                <span className="font-semibold text-foreground">{c.review_count}</span>
                <span>{c.review_count === 1 ? 'review' : 'reviews'}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}